import { ItemsList } from "components/ItemsList";

export const BooksList = ({ books }) => {
  const items = books.filter(Boolean).map((book) => {
    const {
      data: {
        overview_image_crop_center,
        overview_image,
        price,
        summary,
        title,
        writers,
      },
      uid,
      type,
    } = book;

    return {
      cropCenter: overview_image_crop_center,
      link: book,
      text: `<b>${price}</b> – ${summary}`,
      title: `${title} – ${writers}`,
      image: {
        src: overview_image.url,
        alt: overview_image.alt,
      },
    };
  });

  return (
    <ItemsList
      items={items}
      imageSizes={[
        { minWidth: 1024, width: 360, ratio: 1 },
        { minWidth: 900, width: 465, ratio: 1 },
        { minWidth: 768, width: 400, ratio: 1 },
        { minWidth: 700, width: 768, ratio: 1 },
        { minWidth: 600, width: 660, ratio: 1 },
        { minWidth: 500, width: 560, ratio: 1 },
        { minWidth: 400, width: 460, ratio: 1 },
        { minWidth: 345, width: 360, ratio: 1 },
        { minWidth: 1, width: 305, ratio: 1 },
      ]}
    />
  );
};
